import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-logo-portal',
})
export class SignetLogoPortal {
  /**
   * Destination of the Logo
   */
  @Prop() href =  "http://episource.com";
  
  /**
   * SRC of the logo (Optional)
   */
  @Prop() src =  'https://design.episource.com/img/logo/Product=Portal.svg';

  /**
   * Alternative Text
   */
    @Prop() alt =  'Epi Portal Logo';

  private getLogoLink(): string {
    return ( this.href );
  }

  private getImageLink(): string {
    return ( this.src );
  }


  private getAltText(): string {
    return ( this.alt );
  }

  render() {
    return (
      <a class='signet-logo-portal signet-product-icon' href={this.getLogoLink()}><img src={this.getImageLink()} alt={this.getAltText()} /></a>
    );
  }
}
